import { render, staticRenderFns } from "./fancyDynamicTable.vue?vue&type=template&id=895410a0&scoped=true"
import script from "./fancyDynamicTable.vue?vue&type=script&lang=js"
export * from "./fancyDynamicTable.vue?vue&type=script&lang=js"
import style0 from "./fancyDynamicTable.vue?vue&type=style&index=0&id=895410a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895410a0",
  null
  
)

export default component.exports